import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
const SERVICE_AREAS = [{
  name: 'Chattanooga',
  state: 'TN',
  lat: 35.0456,
  lng: -85.3097
}, {
  name: 'Hixson',
  state: 'TN',
  lat: 35.1312,
  lng: -85.2338
}, {
  name: 'Soddy Daisy',
  state: 'TN',
  lat: 35.2359,
  lng: -85.1613
}, {
  name: 'Dayton',
  state: 'TN',
  lat: 35.4934,
  lng: -85.0124
}, {
  name: 'Ooltewah',
  state: 'TN',
  lat: 35.0773,
  lng: -85.0585
}, {
  name: 'Jasper',
  state: 'TN',
  lat: 35.0742,
  lng: -85.6244
}, {
  name: 'Athens',
  state: 'TN',
  lat: 35.4429,
  lng: -84.593
}, {
  name: 'Cleveland',
  state: 'TN',
  lat: 35.1595,
  lng: -84.8766
}, {
  name: 'Rossville',
  state: 'GA',
  lat: 34.9834,
  lng: -85.2863
}, {
  name: 'Fort Oglethorpe',
  state: 'GA',
  lat: 34.9487,
  lng: -85.2569
}, {
  name: 'Dalton',
  state: 'GA',
  lat: 34.7698,
  lng: -84.9702
}];
// Custom gold marker SVG
const goldMarkerSvg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" fill="#D4AF37" stroke="#0A0A0A" stroke-width="1">
  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
</svg>`;
const goldMarkerIcon = L.divIcon({
  html: goldMarkerSvg,
  className: 'custom-gold-marker',
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32]
});
export function ServiceAreaMap() {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<L.Map | null>(null);
  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return;
    const map = L.map(mapRef.current, {
      center: [35.05, -85.15],
      zoom: 9,
      zoomControl: true,
      scrollWheelZoom: false,
      attributionControl: false
    });
    // Dark tile layer to match the black/gold theme
    L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
      maxZoom: 19
    }).addTo(map);
    // Add markers for each service area
    SERVICE_AREAS.forEach(area => {
      const marker = L.marker([area.lat, area.lng], {
        icon: goldMarkerIcon
      }).addTo(map);
      marker.bindPopup(`<div style="font-family: 'Playfair Display', serif; text-align: center; padding: 4px 8px;">
          <strong style="color: #D4AF37; font-size: 14px;">${area.name}</strong>
          <br/>
          <span style="color: #666; font-size: 12px;">${area.state}</span>
        </div>`, {
        className: 'gold-popup'
      });
    });
    // Draw a polygon connecting all areas to show coverage zone
    const polygonCoords: [number, number][] = [[35.4934, -85.0124], [35.4429, -84.593], [35.1595, -84.8766], [35.0773, -85.0585], [34.7698, -84.9702], [34.9487, -85.2569], [34.9834, -85.2863], [35.0456, -85.3097], [35.0742, -85.6244], [35.2359, -85.1613], [35.1312, -85.2338] // Hixson
    ];
    L.polygon(polygonCoords, {
      color: '#D4AF37',
      weight: 2,
      fillColor: '#D4AF37',
      fillOpacity: 0.08,
      dashArray: '8, 4'
    }).addTo(map);
    mapInstanceRef.current = map;
    return () => {
      map.remove();
      mapInstanceRef.current = null;
    };
  }, []);
  return <div className="relative rounded-2xl overflow-hidden border border-brand-gold/20 shadow-xl shadow-brand-gold/5" data-id="element-196">
      <div ref={mapRef} className="w-full h-[400px] md:h-[500px]" data-id="element-197" />
      {/* Gold overlay gradient at edges */}
      <div className="absolute inset-0 pointer-events-none rounded-2xl ring-1 ring-inset ring-brand-gold/10" data-id="element-198"></div>
    </div>;
}